"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = require("@cargoticcom/model");
const deserializeShipmentMatchQuery_1 = __importDefault(require("./deserializeShipmentMatchQuery"));
const deserializeShipmentBoardMatchQuery = (shipments) => ({
    ...(shipments.QUEUE
        ? {
            [model_1.ShipmentState.QUEUE]: deserializeShipmentMatchQuery_1.default(shipments.QUEUE)
        }
        : {}),
    ...(shipments.READY
        ? {
            [model_1.ShipmentState.READY]: deserializeShipmentMatchQuery_1.default(shipments.READY)
        }
        : {}),
    ...(shipments.IN_PROGRESS
        ? {
            [model_1.ShipmentState.IN_PROGRESS]: deserializeShipmentMatchQuery_1.default(shipments.IN_PROGRESS)
        }
        : {}),
    ...(shipments.DONE
        ? {
            [model_1.ShipmentState.DONE]: deserializeShipmentMatchQuery_1.default(shipments.DONE)
        }
        : {})
});
exports.default = deserializeShipmentBoardMatchQuery;
